export default {
  topMenu: {
    openSettings: 'Deschideți setările',
    showAbout: 'Afișați informații generale',
    about: 'Despre ORS',
    pinSidebar: 'Bara laterală Pin',
    settingsTooltip: 'Faceți clic aici dacă doriți să ajustați setările aplicației',
  }
}
